<template>
  <v-dialog v-model="internalVisible" max-width="500" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        small
        @click="internalVisible = !internalVisible"
      >
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </template>
    <v-card :loading="settingLoading">
      <v-card-title class="headline font-weight-bold">
        「小幫手系統通知」設定
        <v-spacer />
        <v-btn icon @click="internalVisible = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>

      <v-card-text v-if="!settingLoading" class="pt-4">
        <div class="d-flex align-center">
          <div>系統通知音效（關/開）：</div>
          <v-switch
            v-model="settings.enabled"
            :loading="isLoading"
            hide-details
            class="mt-0 pt-0"
            @change="onToggle"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getNotificationSoundSettingAPI, setNotificationSoundSettingAPI } from '@/api';
import { NotificationSoundManager } from '@/utils/NotificationSoundManager';
import { mapGetters } from "vuex";

export default {
  name: 'AssistantNotificationSettingDialog',

  data() {
    return {
      internalVisible: false,
      isEnabled: false,
      isLoading: false,
      settings: {},
      settingLoading: false,
    };
  },

  watch: {
    internalVisible(val) {
      if (val) {
        this.fetchSetting();
      }
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData'
    ]),
  },

  methods: {
    async fetchSetting() {
      this.settingLoading = true;
      try {
        const { data } = await getNotificationSoundSettingAPI(this.axiosParamData);
        this.settings = {
          ...NotificationSoundManager.defaultSettings,
          ...data
        }
        this.settingLoading = false;
      } catch (e) {
        console.warn('取得音效設定失敗', e);
      }
    },
    async onToggle() {
      this.isLoading = true;
      try {
        await setNotificationSoundSettingAPI({
          ...this.axiosParamData,
          crm_notification_sound: this.settings
        });
        NotificationSoundManager.toggle(this.settings.enabled);
      } catch (e) {
        this.settings.enabled = !this.settings.enabled;
        this.$notify.error('更新音效設定失敗，請稍後再試一次。')
        console.warn('更新音效設定失敗', e);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>


<style scoped>
/* Your styles here */
</style>
